module.exports = __webpack_public_path__ + "img/taoyuan-2.82a98b15.jpg";